import {
  LayoutDashboard,
  ListChecks,
  PlusCircle,
  FileCheck2,
  ShieldCheck,
  ReceiptText,
  Table2,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { Role } from '@mdu-invoicing/shared';

export interface NavItem {
  path: string;
  label: string; // French (client-facing)
  subtitle: string;
  icon: LucideIcon;
  roles: Role[]; // who sees it
  group: 'main' | 'staff' | 'ref';
  /** Hidden from users without canViewAmounts (the screen is entirely about € — the
   *  tariff grid / PR totals). The route is also guarded; see App.tsx. */
  requiresAmounts?: boolean;
  /** Hidden from anyone who cannot manage accounts (STAFF or a subco ADMIN). Route also guarded. */
  requiresUserManager?: boolean;
}

const BOTH: Role[] = ['STAFF', 'PROVIDER'];
const STAFF: Role[] = ['STAFF'];
const PROVIDER: Role[] = ['PROVIDER'];

export const NAV_ITEMS: NavItem[] = [
  { path: '/dashboard', label: 'Tableau de bord', subtitle: "Vue d'ensemble · Juin 2026", icon: LayoutDashboard, roles: BOTH, group: 'main' },
  { path: '/eligibles', label: 'Éligibles', subtitle: 'Visualisation, filtres, export & import · onglets SSV / TSA', icon: ListChecks, roles: BOTH, group: 'main' },
  { path: '/add', label: 'Ajout d’un cas manqué', subtitle: "Validation d'un MDU_ID contre la source", icon: PlusCircle, roles: PROVIDER, group: 'main' },
  { path: '/document', label: "Documenter l'éligibilité", subtitle: 'Écriture de la décision vers Monday.com', icon: FileCheck2, roles: STAFF, group: 'staff' },
  { path: '/log', label: 'Journal immuable', subtitle: 'Trace inaltérable des enregistrements documentés', icon: ShieldCheck, roles: STAFF, group: 'staff' },
  { path: '/pr', label: 'Aperçu des PR', subtitle: 'Totaux SSV / TSA par zone de déploiement', icon: ReceiptText, roles: STAFF, group: 'staff', requiresAmounts: true },
  { path: '/tariffs', label: 'Grille tarifaire', subtitle: 'Référence des tarifs par contractant (spec §4)', icon: Table2, roles: BOTH, group: 'ref', requiresAmounts: true },
  { path: '/users', label: 'Gestion des comptes', subtitle: 'Comptes des sous-traitants', icon: Users, roles: BOTH, group: 'ref', requiresUserManager: true },
];

export function navForRole(role: Role | undefined, canViewAmounts = true, canManageUsers = false): NavItem[] {
  const byRole = role
    ? NAV_ITEMS.filter((i) => i.roles.includes(role))
    : NAV_ITEMS.filter((i) => i.roles.includes('PROVIDER'));
  return byRole.filter(
    (i) => (canViewAmounts || !i.requiresAmounts) && (canManageUsers || !i.requiresUserManager),
  );
}

export function navItemForPath(path: string): NavItem | undefined {
  return NAV_ITEMS.find((i) => i.path === path);
}
